// extracted by mini-css-extract-plugin
export default {"container":"helpCard_container__-qJD8","left":"helpCard_left__OzjHd","right":"helpCard_right__kPzW2"};